import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { first } from "lodash";
import { Observable, map } from "rxjs";
import { CatalogItem, CatalogItemType } from "src/app/backend/models/catalog";
import { omitUndefinedAndNullProperties } from "src/app/support/object";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class CatalogBackend {
  private readonly http = inject(HttpClient);

  load(id: string): Observable<CatalogItem> {
    return this.http.get<CatalogItem>(
      `${environment.snoots.api.warehouse}/catalogs/${id}`
    );
  }

  find({
    minsan,
    gtin
  }: {
    minsan?: string;
    gtin?: string;
  }): Observable<CatalogItem | undefined> {
    return this.http
      .get<PaginatedResult<CatalogItem>>(
        `${environment.snoots.api.warehouse}/catalogs`,
        {
          params: omitUndefinedAndNullProperties({ minsan, gtin })
        }
      )
      .pipe(map((response) => first(response.docs)));
  }

  search({
    query,
    type
  }: {
    query: string;
    type?: CatalogItemType;
  }): Observable<CatalogItem[]> {
    return this.http
      .get<PaginatedResult<CatalogItem>>(
        `${environment.snoots.api.warehouse}/catalogs`,
        {
          params: omitUndefinedAndNullProperties({
            name: query,
            type
          })
        }
      )
      .pipe(
        map((response: PaginatedResult<CatalogItem>) => {
          return response.docs;
        })
      );
  }

  searchDrugs(query: string): Observable<CatalogItem[]> {
    return this.search({
      type: CatalogItemType.DRUG,
      query
    });
  }

  searchProducts(query: string): Observable<CatalogItem[]> {
    return this.search({
      type: CatalogItemType.PRODUCT,
      query
    });
  }
}
